/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Ref_TitleInputs */

const en_formatter_ref_title = /** @type {(inputs: Formatter_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalizations applied during formatting`)
};

const ko_formatter_ref_title = /** @type {(inputs: Formatter_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`포매팅 중 적용되는 정규화`)
};

const ja_formatter_ref_title = /** @type {(inputs: Formatter_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`整形時に適用される正規化`)
};

/**
* | output |
* | --- |
* | "Normalizations applied during formatting" |
*
* @param {Formatter_Ref_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_ref_title = /** @type {((inputs?: Formatter_Ref_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Ref_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_ref_title(inputs)
	if (locale === "ko") return ko_formatter_ref_title(inputs)
	return ja_formatter_ref_title(inputs)
});